import React from 'react';
import { Check, X } from 'lucide-react';
import './PasswordRequirements.css';  
const PasswordRequirements = ({ password }) => {
    // Requisitos de la contraseña
    const requirements = [
        {
            text: "At least 8 characters",
            test: () => password.length >= 8
        },
        {
            text: "At least one uppercase letter",
            test: () => /[A-Z]/.test(password)
        },
        {
            text: "At least one lowercase letter",
            test: () => /[a-z]/.test(password)
        },
        {
            text: "At least one number",
            test: () => /[0-9]/.test(password)
        },
        {
            text: "At least one special character",
            test: () => /[!@#$%^&*(),.?":{}|<>]/.test(password)
        }
    ];

    return (
        <div className="password-requirements">
            <div className="password-strength-meter">
                <div 
                    className="strength-bar"
                    style={{
                        width: `${(requirements.filter(req => req.test()).length / requirements.length) * 100}%`
                    }}
                />
            </div>
            <div className="requirements-list">
                {requirements.map((req, index) => (
                    <div 
                        key={index} 
                        className={`requirement-item ${req.test() ? 'fulfilled' : ''}`}
                    >
                        {req.test() ? 
                            <Check size={16} className="check-icon" /> : 
                            <X size={16} className="x-icon" />
                        }
                        <span>{req.text}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PasswordRequirements;